import type {
  CrewFormAllotteeRow,
  CrewFormAppraisalRow,
  CrewFormCertRow,
  CrewFormFeedbackRow,
  CrewFormMedicalRow,
  CrewFormNokRow,
  CrewFormPrevServiceRow,
  CrewFormTransactionRow,
} from './formMappers';

const newKey = () => `row-${Date.now()}-${Math.random()}`;

export const emptyCertRow = (): CrewFormCertRow => ({
  key: newKey(),
  certId: '',
  issueCountryId: '',
  certNumber: '',
  issuedDate: '',
  expiredDate: '',
  onVessel: false,
  certFileName: '',
  notes: '',
});

export const emptyAllotteeRow = (): CrewFormAllotteeRow => ({
  key: newKey(),
  fullName: '',
  relationId: '',
  phone: '',
  mobile: '',
  email: '',
  bank: '',
  bankAccount: '',
  amount: '',
  currency: '',
  startDate: '',
  endDate: '',
  frequency: '',
  homeAddress: '',
});

export const emptyNokRow = (): CrewFormNokRow => ({
  key: newKey(),
  fullName: '',
  relationId: '',
  phone: '',
  mobile: '',
  email: '',
  homeAddress: '',
  notes: '',
});

export const emptyAppraisalRow = (): CrewFormAppraisalRow => ({
  key: newKey(),
  appraisalType: '',
  kindId: '',
  questionnaireId: '',
  questionnaireAvg: '',
  vesselId: '',
  assessmentDate: '',
  assessorName: '',
  employStatusId: '',
  toBePromoted: false,
  badHabits: '',
  dismissalReasonId: '',
  dismissalReasonText: '',
  notes: '',
  appraisalFileName: '',
  answers: [],
});

export const emptyFeedbackRow = (): CrewFormFeedbackRow => ({
  key: newKey(),
  feedbackDate: '',
  notes: '',
});

export const emptyPrevServiceRow = (): CrewFormPrevServiceRow => ({
  key: newKey(),
  vesselName: '',
  rankId: '',
  vesselTypeId: '',
  engTypeId: '',
  vesselFlagId: '',
  startDate: '',
  signOnDate: '',
  signOnPort: '',
  signOffDate: '',
  endDate: '',
  signOffPort: '',
  signOffReasonId: '',
  managerName: '',
  manningAgency: '',
  dwt: '',
  grt: '',
  nrt: '',
  engType: '',
  notes: '',
});

export const emptyMedicalRow = (): CrewFormMedicalRow => ({
  key: newKey(),
  kind: 'FITNESS',
  examDate: '',
  nextDueDate: '',
  result: '',
  resultNotes: '',
  clinicName: '',
  certificateNo: '',
  notes: '',
});

export const emptyTransactionRow = (): CrewFormTransactionRow => ({
  key: newKey(),
  status: '',
  vesselId: '',
  vesselName: '',
  rankId: '',
  startDate: '',
  signOnDate: '',
  signOnPort: '',
  signOffDate: '',
  endDate: '',
  signOffPort: '',
  signOffReasonId: '',
  manningAgencyId: '',
  coeDate: '',
  extCoeDate: '',
  priorCoeDate: '',
  latestCoeDate: '',
  totalWage: '',
  wageCurrency: '',
  flWatchkeeper: false,
  includedOt: '',
  intentionSignOffDate: '',
  fileName: '',
  notes: '',
  wageScaleId: '',
  accruedLeaveDays: '',
  leavePayDue: '',
  finalCashDue: '',
  repatriation: '',
  wageValues: {},
});
